import { Loading } from "components/panels";
import React from "react";

interface RecordsCountMessageProps {
  count: number;
  isLoading: boolean;
}

export const RecordsCountMessage = (props: RecordsCountMessageProps) => {
  if (props.isLoading) {
    return <Loading />
  }

  if (props.count === 0) {
    return <div className="s1_red">{RESX.Feed.NoRecordsInQueryAreYouSureThePublicationStatusHasBeenSetCorrectly}</div>
  }

  if (props.count > serverReference.constants.iCalendarFeed.maximumRecords) {
    return <div className="s1_red">{RESX.Feed.XRecordsFoundInQueryWhichExceedTheMaximum.replace("{0}", `${props.count}`)}</div>
  }

  return <div>{props.count} records</div>
}